module.exports = __webpack_public_path__ + "img/product_43.b144cdf.svg";